import { computed } from 'vue';
import { useProfileStore } from '@/js/core/stores/profile-store';

/**
 * Reactive view of whether the current user may create user-generated content
 * (trays, comments). Mirrors the backend gate: the profile must be visible.
 */
export function useProfileVisibility() {
  const profileStore = useProfileStore();

  // Only treat as private when we positively know the profile is hidden. An
  // unloaded profile leaves the server-side gate as the final guard.
  const isProfilePrivate = computed(() => profileStore.profile?.visibility?.is_visible === false);

  const ensureProfileLoaded = () => profileStore.fetchCurrentProfile();

  return { isProfilePrivate, ensureProfileLoaded };
}
